import axios from "axios";
import configData from "../../config/config.json";
import { handleError, handleCallBack } from "./commonStuff";

export const CommonControlPanelKey = "CommonControlPanelKey";
export const HomeSelectionsControlPanelKey = "HomeSelectionsControlPanelKey";
export const HomeLatestNewsControlPanelKey = "HomeLatestNewsControlPanelKey";
export const HomeExternalLinksControlPanelKey = "HomeExternalLinksControlPanelKey";
export const LoginPageLinksControlPanelKey = "LoginPageLinksControlPanelKey";
export const LoginPageLatestNewsControlPanelKey = "LoginPageLatestNewsControlPanelKey";
export const LoginPageSlidesControlPanelKey = "LoginPageSlidesControlPanelKey";
export const LoginPageRegistrationControlPanelKey = "LoginPageRegistrationControlPanelKey";
export const LanguagesControlPanelKey = "LanguagesControlPanelKey";
export const LandNotificationOneAlertsControlPanelKey = "LandNotificationOneAlertsControlPanelKey";
export const HelloWorldControlPanelKey = "HelloWorldControlPanelKey";

export const UserLockoutControlPanelKey = "UserLockoutControlPanelKey";
export const UserLockout2ControlPanelKey = "UserLockout2ControlPanelKey";
export const UserPurgeNowControlPanelKey = "UserPurgeNowControlPanelKey";
export const UserPurgeScheduleControlPanelKey = "UserPurgeScheduleControlPanelKey";
export const UserAccessControlPanelKey = "UserAccessControlPanelKey";
export const UserListControlPanelKey = "UserListControlPanelKey";

export const AlertListControlPanelKey = "AlertListControlPanelKey";
export const EmailListControlPanelKey = "EmailListControlPanelKey";
export const PhoneListControlPanelKey = "PhoneListControlPanelKey";
export const IncomingEventPurgeScheduleControlPanelKey = "IncomingEventPurgeScheduleControlPanelKey";
export const AlertSettingsControlPanelKey = "AlertSettingsControlPanelKey";

export const AuditLogPurgeScheduleControlPanelKey = "AuditLogPurgeScheduleControlPanelKey";
export const AuditLogReportControlPanelKey = "AuditLogReportControlPanelKey";

export const PerformanceMonitoringControlPanelKey = "PerformanceMonitoringControlPanelKey";
export const MultiTenantListControlPanelKey = "MultiTenantListControlPanelKey";

export const setSelectedControlPanelType = (selectedControlPanelType) => {
  return {
    type: 'SET_SELECTED_CONTROL_PANEL_TYPE',
    selectedControlPanelType
  }
}

export const updateAlertListFilters = (filters) => {
  return {
    type: 'SET_ALERT_LIST_FILTERS',
    filters
  }
}

export const setAlertSettings = (alertSettings, callback) => async dispatch => {
  axios.post(configData.LANDNOTIFICATION_SERVER_URL + "controlPanel/countyConfig/alertSettings", alertSettings, { withCredentials: true })
  .then(
    (response) => {
      const content = response.data.content;
      dispatch({ type: 'LANDNOTIFICATION_COUNTY_CONFIG_ALERT_SETTINGS', results: content }, handleCallBack(callback, true, content)); 
    },
    (error) => {
      handleError(error, this.props.history);
    }
  );

}